export default __webpack_public_path__ + "static/Benefits_Chlorinator_HD_411x192-4d969040855370c26c3ce99ff0349690.png";